export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6795.e727438b.jpg";